const user_roles = Object.freeze( [
    {
        id_rol: 0,
        descripcion: "Administrador"
    },
    {
        id_rol: 1,
        descripcion: "Gerente"
    },
    {
        id_rol: 2,
        descripcion: "Jefe(a) de laboratorio"
    },
    {
        id_rol: 3,
        descripcion: "Químico"
    },
    {
        id_rol: 4,
        descripcion: "Analista Químico"
    },
    {
        id_rol: 5,
        descripcion: "Solicitante"
    },
    {
        id_rol: 6,
        descripcion: "Supervisor(a)"
    },
    {
        id_rol: 7,
        descripcion: "Administrador(a) de Finanza"
    },
    {
        id_rol: 8,
        descripcion: "Recepcionista"
    },
   


])

export default user_roles;